import { useCallback, useEffect, useState } from 'react';

export const usePlayerReady = (camPlayer) => {
  const [playerReady, setPlayerReady] = useState(false);

  const handleReady = useCallback(() => {
    // Ensure state is set to true
    setPlayerReady(true);
  }, []);

  useEffect(() => {
    if (camPlayer) {
      camPlayer.on('loadedmetadata', handleReady);
      camPlayer.one('dispose', () => {
        camPlayer.off('loadedmetadata', handleReady);
      });
    }

    return () => {
      if (camPlayer) {
        camPlayer.off('loadedmetadata', handleReady);
      }
    };
  }, [camPlayer, handleReady]);

  return playerReady;
};
